if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.moveMedia(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        if (!this.querySelector('.mm-gallery-arrow')) {
          const gallery = this.openedBy.closest('media-gallery');
          gallery?.querySelectorAll('.mm-gallery-arrow').forEach((source) => {
            const arrow = source.cloneNode(true);
            arrow.addEventListener('pointerup', (event) => event.stopPropagation());
            arrow.addEventListener('click', (event) => {
              event.stopPropagation();
              this.moveMedia(arrow.name === 'next' ? 1 : -1);
            });
            this.querySelector('[role="dialog"]').append(arrow);
          });
        }
      }

      moveMedia(step) {
        const gallery = this.openedBy.closest('media-gallery');
        const allowed = [...gallery.querySelectorAll('.thumbnail-list__item')].filter((item) => item.offsetWidth > 0).map((item) => item.dataset.target.split('-').pop());
        const items = [...this.querySelectorAll('[data-media-id]')].filter((item) => !allowed.length || allowed.includes(item.dataset.mediaId));
        const current = items.findIndex((item) => item.classList.contains('active'));
        const next = items[(current + step + items.length) % items.length];
        if (!next) return;
        this.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('active', item === next));
        window.pauseAllMedia();
        next.querySelector('deferred-media')?.loadContent();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.querySelector('[role="document"]').scrollTop = 0;

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
